module.exports = __webpack_public_path__ + "img/c2.3eefaa5d.svg";